import {nsFa} from "./fn";
import CustomIcons = nsFa.CustomIcons;

type TCustomIconKey = keyof typeof CustomIcons;
export type TIconKey = TCustomIconKey | string;
